import { Snowflake } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/utils/cn'

const FROZEN_TOOLTIP = 'Frozen – editing disabled until unfrozen'

interface FrozenIndicatorProps {
  variant?: 'icon' | 'badge'
  className?: string
}

/**
 * Shared indicator shown wherever a frozen plan appears (lists, detail
 * header, approvals). Reuses the same tooltip pattern as other status
 * affordances in the app.
 */
export function FrozenIndicator({
  variant = 'icon',
  className,
}: FrozenIndicatorProps) {
  if (variant === 'badge') {
    return (
      <TooltipProvider>
        <Tooltip>
          {/* Badge isn't a forwardRef component, so wrap it in a span for
              Radix's asChild ref forwarding. */}
          <TooltipTrigger asChild>
            <span className="inline-flex">
              <Badge
                variant="neutral"
                className={cn('gap-1 font-medium py-1 shrink-0', className)}
              >
                <Snowflake className="h-3.5 w-3.5" />
                Frozen
              </Badge>
            </span>
          </TooltipTrigger>
          <TooltipContent>{FROZEN_TOOLTIP}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Snowflake
            className={cn(
              'h-4 w-4 text-muted-foreground shrink-0 cursor-default',
              className
            )}
          />
        </TooltipTrigger>
        <TooltipContent>{FROZEN_TOOLTIP}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
